/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AnonRouteRouteImport } from './routes/_anon/route'
import { Route as AppRouteRouteImport } from './routes/_app/route'
import { Route as AuthRouteRouteImport } from './routes/_auth/route'
import { Route as AnonLoginRouteImport } from './routes/_anon/login'
import { Route as AppIndexRouteImport } from './routes/_app/index'
import { Route as AppDeveloperRouteRouteImport } from './routes/_app/developer/route'
import { Route as AppFleetManagementRouteRouteImport } from './routes/_app/fleet-management/route'
import { Route as AppUserRouteRouteImport } from './routes/_app/user/route'
import { Route as AuthDeactivatedRouteImport } from './routes/_auth/deactivated'
import { Route as AuthGateRouteImport } from './routes/_auth/gate'
import { Route as AuthNoTenantsRouteImport } from './routes/_auth/no-tenants'
import { Route as AuthOnboardingRouteImport } from './routes/_auth/onboarding'
import { Route as AuthPendingRouteImport } from './routes/_auth/pending'
import { Route as AuthServerErrorRouteImport } from './routes/_auth/server-error'
import { Route as AuthTenantsRouteImport } from './routes/_auth/tenants'
import { Route as AppDeveloperIndexRouteImport } from './routes/_app/developer/index'
import { Route as AppFleetManagementIndexRouteImport } from './routes/_app/fleet-management/index'
import { Route as AppLocationsIndexRouteImport } from './routes/_app/locations/index'
import { Route as AppOrgUnitsIndexRouteImport } from './routes/_app/org-units/index'
import { Route as AppUserIndexRouteImport } from './routes/_app/user/index'
import { Route as AppUsersIndexRouteImport } from './routes/_app/users/index'
import { Route as AppUsersUserIdRouteImport } from './routes/_app/users/$userId'
import { Route as AppDeveloperDemoIndexRouteImport } from './routes/_app/developer/demo/index'
import { Route as AppFleetManagementContractsIndexRouteImport } from './routes/_app/fleet-management/contracts/index'
import { Route as AppFleetManagementContractsContractIdRouteImport } from './routes/_app/fleet-management/contracts/$contractId'
import { Route as AppFleetManagementContractsNewRouteImport } from './routes/_app/fleet-management/contracts/new'
import { Route as AppFleetManagementDigitalVehicleFilesIndexRouteImport } from './routes/_app/fleet-management/digital-vehicle-files/index'
import { Route as AppFleetManagementDigitalVehicleFilesSplatRouteImport } from './routes/_app/fleet-management/digital-vehicle-files/$'
import { Route as AppFleetManagementDriversIndexRouteImport } from './routes/_app/fleet-management/drivers/index'
import { Route as AppFleetManagementDriversDriverIdRouteImport } from './routes/_app/fleet-management/drivers/$driverId'
import { Route as AppFleetManagementDriversNewRouteImport } from './routes/_app/fleet-management/drivers/new'
import { Route as AppFleetManagementVehiclesIndexRouteImport } from './routes/_app/fleet-management/vehicles/index'
import { Route as AppFleetManagementVehiclesVehicleIdRouteImport } from './routes/_app/fleet-management/vehicles/$vehicleId'
import { Route as AppFleetManagementVehiclesNewRouteImport } from './routes/_app/fleet-management/vehicles/new'
import { Route as AppUserAccountIndexRouteImport } from './routes/_app/user/account/index'
import { Route as AppUserBillingIndexRouteImport } from './routes/_app/user/billing/index'
import { Route as AppUserLogoutIndexRouteImport } from './routes/_app/user/logout/index'
import { Route as AppUserNotificationsIndexRouteImport } from './routes/_app/user/notifications/index'

const AnonRouteRoute = AnonRouteRouteImport.update({
  id: '/_anon',
  getParentRoute: () => rootRouteImport,
} as any)
const AppRouteRoute = AppRouteRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRouteRoute = AuthRouteRouteImport.update({
  id: '/_auth',
  getParentRoute: () => rootRouteImport,
} as any)
const AnonLoginRoute = AnonLoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => AnonRouteRoute,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppDeveloperRouteRoute = AppDeveloperRouteRouteImport.update({
  id: '/developer',
  path: '/developer',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppFleetManagementRouteRoute = AppFleetManagementRouteRouteImport.update({
  id: '/fleet-management',
  path: '/fleet-management',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppUserRouteRoute = AppUserRouteRouteImport.update({
  id: '/user',
  path: '/user',
  getParentRoute: () => AppRouteRoute,
} as any)
const AuthDeactivatedRoute = AuthDeactivatedRouteImport.update({
  id: '/deactivated',
  path: '/deactivated',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthGateRoute = AuthGateRouteImport.update({
  id: '/gate',
  path: '/gate',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthNoTenantsRoute = AuthNoTenantsRouteImport.update({
  id: '/no-tenants',
  path: '/no-tenants',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthOnboardingRoute = AuthOnboardingRouteImport.update({
  id: '/onboarding',
  path: '/onboarding',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthPendingRoute = AuthPendingRouteImport.update({
  id: '/pending',
  path: '/pending',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthServerErrorRoute = AuthServerErrorRouteImport.update({
  id: '/server-error',
  path: '/server-error',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthTenantsRoute = AuthTenantsRouteImport.update({
  id: '/tenants',
  path: '/tenants',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AppDeveloperIndexRoute = AppDeveloperIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppDeveloperRouteRoute,
} as any)
const AppFleetManagementIndexRoute = AppFleetManagementIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppFleetManagementRouteRoute,
} as any)
const AppLocationsIndexRoute = AppLocationsIndexRouteImport.update({
  id: '/locations/',
  path: '/locations/',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppOrgUnitsIndexRoute = AppOrgUnitsIndexRouteImport.update({
  id: '/org-units/',
  path: '/org-units/',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppUserIndexRoute = AppUserIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppUserRouteRoute,
} as any)
const AppUsersIndexRoute = AppUsersIndexRouteImport.update({
  id: '/users/',
  path: '/users/',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppUsersUserIdRoute = AppUsersUserIdRouteImport.update({
  id: '/users/$userId',
  path: '/users/$userId',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppDeveloperDemoIndexRoute = AppDeveloperDemoIndexRouteImport.update({
  id: '/demo/',
  path: '/demo/',
  getParentRoute: () => AppDeveloperRouteRoute,
} as any)
const AppFleetManagementContractsIndexRoute =
  AppFleetManagementContractsIndexRouteImport.update({
    id: '/contracts/',
    path: '/contracts/',
    getParentRoute: () => AppFleetManagementRouteRoute,
  } as any)
const AppFleetManagementContractsContractIdRoute =
  AppFleetManagementContractsContractIdRouteImport.update({
    id: '/contracts/$contractId',
    path: '/contracts/$contractId',
    getParentRoute: () => AppFleetManagementRouteRoute,
  } as any)
const AppFleetManagementContractsNewRoute =
  AppFleetManagementContractsNewRouteImport.update({
    id: '/contracts/new',
    path: '/contracts/new',
    getParentRoute: () => AppFleetManagementRouteRoute,
  } as any)
const AppFleetManagementDigitalVehicleFilesIndexRoute =
  AppFleetManagementDigitalVehicleFilesIndexRouteImport.update({
    id: '/digital-vehicle-files/',
    path: '/digital-vehicle-files/',
    getParentRoute: () => AppFleetManagementRouteRoute,
  } as any)
const AppFleetManagementDigitalVehicleFilesSplatRoute =
  AppFleetManagementDigitalVehicleFilesSplatRouteImport.update({
    id: '/digital-vehicle-files/$',
    path: '/digital-vehicle-files/$',
    getParentRoute: () => AppFleetManagementRouteRoute,
  } as any)
const AppFleetManagementDriversIndexRoute =
  AppFleetManagementDriversIndexRouteImport.update({
    id: '/drivers/',
    path: '/drivers/',
    getParentRoute: () => AppFleetManagementRouteRoute,
  } as any)
const AppFleetManagementDriversDriverIdRoute =
  AppFleetManagementDriversDriverIdRouteImport.update({
    id: '/drivers/$driverId',
    path: '/drivers/$driverId',
    getParentRoute: () => AppFleetManagementRouteRoute,
  } as any)
const AppFleetManagementDriversNewRoute =
  AppFleetManagementDriversNewRouteImport.update({
    id: '/drivers/new',
    path: '/drivers/new',
    getParentRoute: () => AppFleetManagementRouteRoute,
  } as any)
const AppFleetManagementVehiclesIndexRoute =
  AppFleetManagementVehiclesIndexRouteImport.update({
    id: '/vehicles/',
    path: '/vehicles/',
    getParentRoute: () => AppFleetManagementRouteRoute,
  } as any)
const AppFleetManagementVehiclesVehicleIdRoute =
  AppFleetManagementVehiclesVehicleIdRouteImport.update({
    id: '/vehicles/$vehicleId',
    path: '/vehicles/$vehicleId',
    getParentRoute: () => AppFleetManagementRouteRoute,
  } as any)
const AppFleetManagementVehiclesNewRoute =
  AppFleetManagementVehiclesNewRouteImport.update({
    id: '/vehicles/new',
    path: '/vehicles/new',
    getParentRoute: () => AppFleetManagementRouteRoute,
  } as any)
const AppUserAccountIndexRoute = AppUserAccountIndexRouteImport.update({
  id: '/account/',
  path: '/account/',
  getParentRoute: () => AppUserRouteRoute,
} as any)
const AppUserBillingIndexRoute = AppUserBillingIndexRouteImport.update({
  id: '/billing/',
  path: '/billing/',
  getParentRoute: () => AppUserRouteRoute,
} as any)
const AppUserLogoutIndexRoute = AppUserLogoutIndexRouteImport.update({
  id: '/logout/',
  path: '/logout/',
  getParentRoute: () => AppUserRouteRoute,
} as any)
const AppUserNotificationsIndexRoute =
  AppUserNotificationsIndexRouteImport.update({
    id: '/notifications/',
    path: '/notifications/',
    getParentRoute: () => AppUserRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof AppIndexRoute
  '/developer': typeof AppDeveloperRouteRouteWithChildren
  '/fleet-management': typeof AppFleetManagementRouteRouteWithChildren
  '/user': typeof AppUserRouteRouteWithChildren
  '/login': typeof AnonLoginRoute
  '/deactivated': typeof AuthDeactivatedRoute
  '/gate': typeof AuthGateRoute
  '/no-tenants': typeof AuthNoTenantsRoute
  '/onboarding': typeof AuthOnboardingRoute
  '/pending': typeof AuthPendingRoute
  '/server-error': typeof AuthServerErrorRoute
  '/tenants': typeof AuthTenantsRoute
  '/users/$userId': typeof AppUsersUserIdRoute
  '/developer/': typeof AppDeveloperIndexRoute
  '/fleet-management/': typeof AppFleetManagementIndexRoute
  '/locations/': typeof AppLocationsIndexRoute
  '/org-units/': typeof AppOrgUnitsIndexRoute
  '/user/': typeof AppUserIndexRoute
  '/users/': typeof AppUsersIndexRoute
  '/fleet-management/contracts/$contractId': typeof AppFleetManagementContractsContractIdRoute
  '/fleet-management/contracts/new': typeof AppFleetManagementContractsNewRoute
  '/fleet-management/digital-vehicle-files/$': typeof AppFleetManagementDigitalVehicleFilesSplatRoute
  '/fleet-management/drivers/$driverId': typeof AppFleetManagementDriversDriverIdRoute
  '/fleet-management/drivers/new': typeof AppFleetManagementDriversNewRoute
  '/fleet-management/vehicles/$vehicleId': typeof AppFleetManagementVehiclesVehicleIdRoute
  '/fleet-management/vehicles/new': typeof AppFleetManagementVehiclesNewRoute
  '/developer/demo/': typeof AppDeveloperDemoIndexRoute
  '/fleet-management/contracts/': typeof AppFleetManagementContractsIndexRoute
  '/fleet-management/digital-vehicle-files/': typeof AppFleetManagementDigitalVehicleFilesIndexRoute
  '/fleet-management/drivers/': typeof AppFleetManagementDriversIndexRoute
  '/fleet-management/vehicles/': typeof AppFleetManagementVehiclesIndexRoute
  '/user/account/': typeof AppUserAccountIndexRoute
  '/user/billing/': typeof AppUserBillingIndexRoute
  '/user/logout/': typeof AppUserLogoutIndexRoute
  '/user/notifications/': typeof AppUserNotificationsIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof AppIndexRoute
  '/login': typeof AnonLoginRoute
  '/deactivated': typeof AuthDeactivatedRoute
  '/gate': typeof AuthGateRoute
  '/no-tenants': typeof AuthNoTenantsRoute
  '/onboarding': typeof AuthOnboardingRoute
  '/pending': typeof AuthPendingRoute
  '/server-error': typeof AuthServerErrorRoute
  '/tenants': typeof AuthTenantsRoute
  '/users/$userId': typeof AppUsersUserIdRoute
  '/developer': typeof AppDeveloperIndexRoute
  '/fleet-management': typeof AppFleetManagementIndexRoute
  '/locations': typeof AppLocationsIndexRoute
  '/org-units': typeof AppOrgUnitsIndexRoute
  '/user': typeof AppUserIndexRoute
  '/users': typeof AppUsersIndexRoute
  '/fleet-management/contracts/$contractId': typeof AppFleetManagementContractsContractIdRoute
  '/fleet-management/contracts/new': typeof AppFleetManagementContractsNewRoute
  '/fleet-management/digital-vehicle-files/$': typeof AppFleetManagementDigitalVehicleFilesSplatRoute
  '/fleet-management/drivers/$driverId': typeof AppFleetManagementDriversDriverIdRoute
  '/fleet-management/drivers/new': typeof AppFleetManagementDriversNewRoute
  '/fleet-management/vehicles/$vehicleId': typeof AppFleetManagementVehiclesVehicleIdRoute
  '/fleet-management/vehicles/new': typeof AppFleetManagementVehiclesNewRoute
  '/developer/demo': typeof AppDeveloperDemoIndexRoute
  '/fleet-management/contracts': typeof AppFleetManagementContractsIndexRoute
  '/fleet-management/digital-vehicle-files': typeof AppFleetManagementDigitalVehicleFilesIndexRoute
  '/fleet-management/drivers': typeof AppFleetManagementDriversIndexRoute
  '/fleet-management/vehicles': typeof AppFleetManagementVehiclesIndexRoute
  '/user/account': typeof AppUserAccountIndexRoute
  '/user/billing': typeof AppUserBillingIndexRoute
  '/user/logout': typeof AppUserLogoutIndexRoute
  '/user/notifications': typeof AppUserNotificationsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_anon': typeof AnonRouteRouteWithChildren
  '/_app': typeof AppRouteRouteWithChildren
  '/_auth': typeof AuthRouteRouteWithChildren
  '/_app/developer': typeof AppDeveloperRouteRouteWithChildren
  '/_app/fleet-management': typeof AppFleetManagementRouteRouteWithChildren
  '/_app/user': typeof AppUserRouteRouteWithChildren
  '/_anon/login': typeof AnonLoginRoute
  '/_auth/deactivated': typeof AuthDeactivatedRoute
  '/_auth/gate': typeof AuthGateRoute
  '/_auth/no-tenants': typeof AuthNoTenantsRoute
  '/_auth/onboarding': typeof AuthOnboardingRoute
  '/_auth/pending': typeof AuthPendingRoute
  '/_auth/server-error': typeof AuthServerErrorRoute
  '/_auth/tenants': typeof AuthTenantsRoute
  '/_app/': typeof AppIndexRoute
  '/_app/users/$userId': typeof AppUsersUserIdRoute
  '/_app/developer/': typeof AppDeveloperIndexRoute
  '/_app/fleet-management/': typeof AppFleetManagementIndexRoute
  '/_app/locations/': typeof AppLocationsIndexRoute
  '/_app/org-units/': typeof AppOrgUnitsIndexRoute
  '/_app/user/': typeof AppUserIndexRoute
  '/_app/users/': typeof AppUsersIndexRoute
  '/_app/fleet-management/contracts/$contractId': typeof AppFleetManagementContractsContractIdRoute
  '/_app/fleet-management/contracts/new': typeof AppFleetManagementContractsNewRoute
  '/_app/fleet-management/digital-vehicle-files/$': typeof AppFleetManagementDigitalVehicleFilesSplatRoute
  '/_app/fleet-management/drivers/$driverId': typeof AppFleetManagementDriversDriverIdRoute
  '/_app/fleet-management/drivers/new': typeof AppFleetManagementDriversNewRoute
  '/_app/fleet-management/vehicles/$vehicleId': typeof AppFleetManagementVehiclesVehicleIdRoute
  '/_app/fleet-management/vehicles/new': typeof AppFleetManagementVehiclesNewRoute
  '/_app/developer/demo/': typeof AppDeveloperDemoIndexRoute
  '/_app/fleet-management/contracts/': typeof AppFleetManagementContractsIndexRoute
  '/_app/fleet-management/digital-vehicle-files/': typeof AppFleetManagementDigitalVehicleFilesIndexRoute
  '/_app/fleet-management/drivers/': typeof AppFleetManagementDriversIndexRoute
  '/_app/fleet-management/vehicles/': typeof AppFleetManagementVehiclesIndexRoute
  '/_app/user/account/': typeof AppUserAccountIndexRoute
  '/_app/user/billing/': typeof AppUserBillingIndexRoute
  '/_app/user/logout/': typeof AppUserLogoutIndexRoute
  '/_app/user/notifications/': typeof AppUserNotificationsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/developer'
    | '/fleet-management'
    | '/user'
    | '/login'
    | '/deactivated'
    | '/gate'
    | '/no-tenants'
    | '/onboarding'
    | '/pending'
    | '/server-error'
    | '/tenants'
    | '/users/$userId'
    | '/developer/'
    | '/fleet-management/'
    | '/locations/'
    | '/org-units/'
    | '/user/'
    | '/users/'
    | '/fleet-management/contracts/$contractId'
    | '/fleet-management/contracts/new'
    | '/fleet-management/digital-vehicle-files/$'
    | '/fleet-management/drivers/$driverId'
    | '/fleet-management/drivers/new'
    | '/fleet-management/vehicles/$vehicleId'
    | '/fleet-management/vehicles/new'
    | '/developer/demo/'
    | '/fleet-management/contracts/'
    | '/fleet-management/digital-vehicle-files/'
    | '/fleet-management/drivers/'
    | '/fleet-management/vehicles/'
    | '/user/account/'
    | '/user/billing/'
    | '/user/logout/'
    | '/user/notifications/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/login'
    | '/deactivated'
    | '/gate'
    | '/no-tenants'
    | '/onboarding'
    | '/pending'
    | '/server-error'
    | '/tenants'
    | '/users/$userId'
    | '/developer'
    | '/fleet-management'
    | '/locations'
    | '/org-units'
    | '/user'
    | '/users'
    | '/fleet-management/contracts/$contractId'
    | '/fleet-management/contracts/new'
    | '/fleet-management/digital-vehicle-files/$'
    | '/fleet-management/drivers/$driverId'
    | '/fleet-management/drivers/new'
    | '/fleet-management/vehicles/$vehicleId'
    | '/fleet-management/vehicles/new'
    | '/developer/demo'
    | '/fleet-management/contracts'
    | '/fleet-management/digital-vehicle-files'
    | '/fleet-management/drivers'
    | '/fleet-management/vehicles'
    | '/user/account'
    | '/user/billing'
    | '/user/logout'
    | '/user/notifications'
  id:
    | '__root__'
    | '/_anon'
    | '/_app'
    | '/_auth'
    | '/_app/developer'
    | '/_app/fleet-management'
    | '/_app/user'
    | '/_anon/login'
    | '/_auth/deactivated'
    | '/_auth/gate'
    | '/_auth/no-tenants'
    | '/_auth/onboarding'
    | '/_auth/pending'
    | '/_auth/server-error'
    | '/_auth/tenants'
    | '/_app/'
    | '/_app/users/$userId'
    | '/_app/developer/'
    | '/_app/fleet-management/'
    | '/_app/locations/'
    | '/_app/org-units/'
    | '/_app/user/'
    | '/_app/users/'
    | '/_app/fleet-management/contracts/$contractId'
    | '/_app/fleet-management/contracts/new'
    | '/_app/fleet-management/digital-vehicle-files/$'
    | '/_app/fleet-management/drivers/$driverId'
    | '/_app/fleet-management/drivers/new'
    | '/_app/fleet-management/vehicles/$vehicleId'
    | '/_app/fleet-management/vehicles/new'
    | '/_app/developer/demo/'
    | '/_app/fleet-management/contracts/'
    | '/_app/fleet-management/digital-vehicle-files/'
    | '/_app/fleet-management/drivers/'
    | '/_app/fleet-management/vehicles/'
    | '/_app/user/account/'
    | '/_app/user/billing/'
    | '/_app/user/logout/'
    | '/_app/user/notifications/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AnonRouteRoute: typeof AnonRouteRouteWithChildren
  AppRouteRoute: typeof AppRouteRouteWithChildren
  AuthRouteRoute: typeof AuthRouteRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_anon': {
      id: '/_anon'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AnonRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_anon/login': {
      id: '/_anon/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof AnonLoginRouteImport
      parentRoute: typeof AnonRouteRoute
    }
    '/_app/': {
      id: '/_app/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/developer': {
      id: '/_app/developer'
      path: '/developer'
      fullPath: '/developer'
      preLoaderRoute: typeof AppDeveloperRouteRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/fleet-management': {
      id: '/_app/fleet-management'
      path: '/fleet-management'
      fullPath: '/fleet-management'
      preLoaderRoute: typeof AppFleetManagementRouteRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/user': {
      id: '/_app/user'
      path: '/user'
      fullPath: '/user'
      preLoaderRoute: typeof AppUserRouteRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_auth/deactivated': {
      id: '/_auth/deactivated'
      path: '/deactivated'
      fullPath: '/deactivated'
      preLoaderRoute: typeof AuthDeactivatedRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/gate': {
      id: '/_auth/gate'
      path: '/gate'
      fullPath: '/gate'
      preLoaderRoute: typeof AuthGateRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/no-tenants': {
      id: '/_auth/no-tenants'
      path: '/no-tenants'
      fullPath: '/no-tenants'
      preLoaderRoute: typeof AuthNoTenantsRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/onboarding': {
      id: '/_auth/onboarding'
      path: '/onboarding'
      fullPath: '/onboarding'
      preLoaderRoute: typeof AuthOnboardingRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/pending': {
      id: '/_auth/pending'
      path: '/pending'
      fullPath: '/pending'
      preLoaderRoute: typeof AuthPendingRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/server-error': {
      id: '/_auth/server-error'
      path: '/server-error'
      fullPath: '/server-error'
      preLoaderRoute: typeof AuthServerErrorRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/tenants': {
      id: '/_auth/tenants'
      path: '/tenants'
      fullPath: '/tenants'
      preLoaderRoute: typeof AuthTenantsRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_app/developer/': {
      id: '/_app/developer/'
      path: '/'
      fullPath: '/developer/'
      preLoaderRoute: typeof AppDeveloperIndexRouteImport
      parentRoute: typeof AppDeveloperRouteRoute
    }
    '/_app/fleet-management/': {
      id: '/_app/fleet-management/'
      path: '/'
      fullPath: '/fleet-management/'
      preLoaderRoute: typeof AppFleetManagementIndexRouteImport
      parentRoute: typeof AppFleetManagementRouteRoute
    }
    '/_app/locations/': {
      id: '/_app/locations/'
      path: '/locations'
      fullPath: '/locations/'
      preLoaderRoute: typeof AppLocationsIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/org-units/': {
      id: '/_app/org-units/'
      path: '/org-units'
      fullPath: '/org-units/'
      preLoaderRoute: typeof AppOrgUnitsIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/user/': {
      id: '/_app/user/'
      path: '/'
      fullPath: '/user/'
      preLoaderRoute: typeof AppUserIndexRouteImport
      parentRoute: typeof AppUserRouteRoute
    }
    '/_app/users/': {
      id: '/_app/users/'
      path: '/users'
      fullPath: '/users/'
      preLoaderRoute: typeof AppUsersIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/users/$userId': {
      id: '/_app/users/$userId'
      path: '/users/$userId'
      fullPath: '/users/$userId'
      preLoaderRoute: typeof AppUsersUserIdRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/developer/demo/': {
      id: '/_app/developer/demo/'
      path: '/demo'
      fullPath: '/developer/demo/'
      preLoaderRoute: typeof AppDeveloperDemoIndexRouteImport
      parentRoute: typeof AppDeveloperRouteRoute
    }
    '/_app/fleet-management/contracts/': {
      id: '/_app/fleet-management/contracts/'
      path: '/contracts'
      fullPath: '/fleet-management/contracts/'
      preLoaderRoute: typeof AppFleetManagementContractsIndexRouteImport
      parentRoute: typeof AppFleetManagementRouteRoute
    }
    '/_app/fleet-management/contracts/$contractId': {
      id: '/_app/fleet-management/contracts/$contractId'
      path: '/contracts/$contractId'
      fullPath: '/fleet-management/contracts/$contractId'
      preLoaderRoute: typeof AppFleetManagementContractsContractIdRouteImport
      parentRoute: typeof AppFleetManagementRouteRoute
    }
    '/_app/fleet-management/contracts/new': {
      id: '/_app/fleet-management/contracts/new'
      path: '/contracts/new'
      fullPath: '/fleet-management/contracts/new'
      preLoaderRoute: typeof AppFleetManagementContractsNewRouteImport
      parentRoute: typeof AppFleetManagementRouteRoute
    }
    '/_app/fleet-management/digital-vehicle-files/': {
      id: '/_app/fleet-management/digital-vehicle-files/'
      path: '/digital-vehicle-files'
      fullPath: '/fleet-management/digital-vehicle-files/'
      preLoaderRoute: typeof AppFleetManagementDigitalVehicleFilesIndexRouteImport
      parentRoute: typeof AppFleetManagementRouteRoute
    }
    '/_app/fleet-management/digital-vehicle-files/$': {
      id: '/_app/fleet-management/digital-vehicle-files/$'
      path: '/digital-vehicle-files/$'
      fullPath: '/fleet-management/digital-vehicle-files/$'
      preLoaderRoute: typeof AppFleetManagementDigitalVehicleFilesSplatRouteImport
      parentRoute: typeof AppFleetManagementRouteRoute
    }
    '/_app/fleet-management/drivers/': {
      id: '/_app/fleet-management/drivers/'
      path: '/drivers'
      fullPath: '/fleet-management/drivers/'
      preLoaderRoute: typeof AppFleetManagementDriversIndexRouteImport
      parentRoute: typeof AppFleetManagementRouteRoute
    }
    '/_app/fleet-management/drivers/$driverId': {
      id: '/_app/fleet-management/drivers/$driverId'
      path: '/drivers/$driverId'
      fullPath: '/fleet-management/drivers/$driverId'
      preLoaderRoute: typeof AppFleetManagementDriversDriverIdRouteImport
      parentRoute: typeof AppFleetManagementRouteRoute
    }
    '/_app/fleet-management/drivers/new': {
      id: '/_app/fleet-management/drivers/new'
      path: '/drivers/new'
      fullPath: '/fleet-management/drivers/new'
      preLoaderRoute: typeof AppFleetManagementDriversNewRouteImport
      parentRoute: typeof AppFleetManagementRouteRoute
    }
    '/_app/fleet-management/vehicles/': {
      id: '/_app/fleet-management/vehicles/'
      path: '/vehicles'
      fullPath: '/fleet-management/vehicles/'
      preLoaderRoute: typeof AppFleetManagementVehiclesIndexRouteImport
      parentRoute: typeof AppFleetManagementRouteRoute
    }
    '/_app/fleet-management/vehicles/$vehicleId': {
      id: '/_app/fleet-management/vehicles/$vehicleId'
      path: '/vehicles/$vehicleId'
      fullPath: '/fleet-management/vehicles/$vehicleId'
      preLoaderRoute: typeof AppFleetManagementVehiclesVehicleIdRouteImport
      parentRoute: typeof AppFleetManagementRouteRoute
    }
    '/_app/fleet-management/vehicles/new': {
      id: '/_app/fleet-management/vehicles/new'
      path: '/vehicles/new'
      fullPath: '/fleet-management/vehicles/new'
      preLoaderRoute: typeof AppFleetManagementVehiclesNewRouteImport
      parentRoute: typeof AppFleetManagementRouteRoute
    }
    '/_app/user/account/': {
      id: '/_app/user/account/'
      path: '/account'
      fullPath: '/user/account/'
      preLoaderRoute: typeof AppUserAccountIndexRouteImport
      parentRoute: typeof AppUserRouteRoute
    }
    '/_app/user/billing/': {
      id: '/_app/user/billing/'
      path: '/billing'
      fullPath: '/user/billing/'
      preLoaderRoute: typeof AppUserBillingIndexRouteImport
      parentRoute: typeof AppUserRouteRoute
    }
    '/_app/user/logout/': {
      id: '/_app/user/logout/'
      path: '/logout'
      fullPath: '/user/logout/'
      preLoaderRoute: typeof AppUserLogoutIndexRouteImport
      parentRoute: typeof AppUserRouteRoute
    }
    '/_app/user/notifications/': {
      id: '/_app/user/notifications/'
      path: '/notifications'
      fullPath: '/user/notifications/'
      preLoaderRoute: typeof AppUserNotificationsIndexRouteImport
      parentRoute: typeof AppUserRouteRoute
    }
  }
}

interface AnonRouteRouteChildren {
  AnonLoginRoute: typeof AnonLoginRoute
}

const AnonRouteRouteChildren: AnonRouteRouteChildren = {
  AnonLoginRoute: AnonLoginRoute,
}

const AnonRouteRouteWithChildren = AnonRouteRoute._addFileChildren(
  AnonRouteRouteChildren,
)

interface AppDeveloperRouteRouteChildren {
  AppDeveloperIndexRoute: typeof AppDeveloperIndexRoute
  AppDeveloperDemoIndexRoute: typeof AppDeveloperDemoIndexRoute
}

const AppDeveloperRouteRouteChildren: AppDeveloperRouteRouteChildren = {
  AppDeveloperIndexRoute: AppDeveloperIndexRoute,
  AppDeveloperDemoIndexRoute: AppDeveloperDemoIndexRoute,
}

const AppDeveloperRouteRouteWithChildren =
  AppDeveloperRouteRoute._addFileChildren(AppDeveloperRouteRouteChildren)

interface AppFleetManagementRouteRouteChildren {
  AppFleetManagementIndexRoute: typeof AppFleetManagementIndexRoute
  AppFleetManagementContractsContractIdRoute: typeof AppFleetManagementContractsContractIdRoute
  AppFleetManagementContractsNewRoute: typeof AppFleetManagementContractsNewRoute
  AppFleetManagementDigitalVehicleFilesSplatRoute: typeof AppFleetManagementDigitalVehicleFilesSplatRoute
  AppFleetManagementDriversDriverIdRoute: typeof AppFleetManagementDriversDriverIdRoute
  AppFleetManagementDriversNewRoute: typeof AppFleetManagementDriversNewRoute
  AppFleetManagementVehiclesVehicleIdRoute: typeof AppFleetManagementVehiclesVehicleIdRoute
  AppFleetManagementVehiclesNewRoute: typeof AppFleetManagementVehiclesNewRoute
  AppFleetManagementContractsIndexRoute: typeof AppFleetManagementContractsIndexRoute
  AppFleetManagementDigitalVehicleFilesIndexRoute: typeof AppFleetManagementDigitalVehicleFilesIndexRoute
  AppFleetManagementDriversIndexRoute: typeof AppFleetManagementDriversIndexRoute
  AppFleetManagementVehiclesIndexRoute: typeof AppFleetManagementVehiclesIndexRoute
}

const AppFleetManagementRouteRouteChildren: AppFleetManagementRouteRouteChildren =
  {
    AppFleetManagementIndexRoute: AppFleetManagementIndexRoute,
    AppFleetManagementContractsContractIdRoute:
      AppFleetManagementContractsContractIdRoute,
    AppFleetManagementContractsNewRoute: AppFleetManagementContractsNewRoute,
    AppFleetManagementDigitalVehicleFilesSplatRoute:
      AppFleetManagementDigitalVehicleFilesSplatRoute,
    AppFleetManagementDriversDriverIdRoute:
      AppFleetManagementDriversDriverIdRoute,
    AppFleetManagementDriversNewRoute: AppFleetManagementDriversNewRoute,
    AppFleetManagementVehiclesVehicleIdRoute:
      AppFleetManagementVehiclesVehicleIdRoute,
    AppFleetManagementVehiclesNewRoute: AppFleetManagementVehiclesNewRoute,
    AppFleetManagementContractsIndexRoute:
      AppFleetManagementContractsIndexRoute,
    AppFleetManagementDigitalVehicleFilesIndexRoute:
      AppFleetManagementDigitalVehicleFilesIndexRoute,
    AppFleetManagementDriversIndexRoute: AppFleetManagementDriversIndexRoute,
    AppFleetManagementVehiclesIndexRoute: AppFleetManagementVehiclesIndexRoute,
  }

const AppFleetManagementRouteRouteWithChildren =
  AppFleetManagementRouteRoute._addFileChildren(
    AppFleetManagementRouteRouteChildren,
  )

interface AppUserRouteRouteChildren {
  AppUserIndexRoute: typeof AppUserIndexRoute
  AppUserAccountIndexRoute: typeof AppUserAccountIndexRoute
  AppUserBillingIndexRoute: typeof AppUserBillingIndexRoute
  AppUserLogoutIndexRoute: typeof AppUserLogoutIndexRoute
  AppUserNotificationsIndexRoute: typeof AppUserNotificationsIndexRoute
}

const AppUserRouteRouteChildren: AppUserRouteRouteChildren = {
  AppUserIndexRoute: AppUserIndexRoute,
  AppUserAccountIndexRoute: AppUserAccountIndexRoute,
  AppUserBillingIndexRoute: AppUserBillingIndexRoute,
  AppUserLogoutIndexRoute: AppUserLogoutIndexRoute,
  AppUserNotificationsIndexRoute: AppUserNotificationsIndexRoute,
}

const AppUserRouteRouteWithChildren = AppUserRouteRoute._addFileChildren(
  AppUserRouteRouteChildren,
)

interface AppRouteRouteChildren {
  AppDeveloperRouteRoute: typeof AppDeveloperRouteRouteWithChildren
  AppFleetManagementRouteRoute: typeof AppFleetManagementRouteRouteWithChildren
  AppUserRouteRoute: typeof AppUserRouteRouteWithChildren
  AppIndexRoute: typeof AppIndexRoute
  AppUsersUserIdRoute: typeof AppUsersUserIdRoute
  AppLocationsIndexRoute: typeof AppLocationsIndexRoute
  AppOrgUnitsIndexRoute: typeof AppOrgUnitsIndexRoute
  AppUsersIndexRoute: typeof AppUsersIndexRoute
}

const AppRouteRouteChildren: AppRouteRouteChildren = {
  AppDeveloperRouteRoute: AppDeveloperRouteRouteWithChildren,
  AppFleetManagementRouteRoute: AppFleetManagementRouteRouteWithChildren,
  AppUserRouteRoute: AppUserRouteRouteWithChildren,
  AppIndexRoute: AppIndexRoute,
  AppUsersUserIdRoute: AppUsersUserIdRoute,
  AppLocationsIndexRoute: AppLocationsIndexRoute,
  AppOrgUnitsIndexRoute: AppOrgUnitsIndexRoute,
  AppUsersIndexRoute: AppUsersIndexRoute,
}

const AppRouteRouteWithChildren = AppRouteRoute._addFileChildren(
  AppRouteRouteChildren,
)

interface AuthRouteRouteChildren {
  AuthDeactivatedRoute: typeof AuthDeactivatedRoute
  AuthGateRoute: typeof AuthGateRoute
  AuthNoTenantsRoute: typeof AuthNoTenantsRoute
  AuthOnboardingRoute: typeof AuthOnboardingRoute
  AuthPendingRoute: typeof AuthPendingRoute
  AuthServerErrorRoute: typeof AuthServerErrorRoute
  AuthTenantsRoute: typeof AuthTenantsRoute
}

const AuthRouteRouteChildren: AuthRouteRouteChildren = {
  AuthDeactivatedRoute: AuthDeactivatedRoute,
  AuthGateRoute: AuthGateRoute,
  AuthNoTenantsRoute: AuthNoTenantsRoute,
  AuthOnboardingRoute: AuthOnboardingRoute,
  AuthPendingRoute: AuthPendingRoute,
  AuthServerErrorRoute: AuthServerErrorRoute,
  AuthTenantsRoute: AuthTenantsRoute,
}

const AuthRouteRouteWithChildren = AuthRouteRoute._addFileChildren(
  AuthRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  AnonRouteRoute: AnonRouteRouteWithChildren,
  AppRouteRoute: AppRouteRouteWithChildren,
  AuthRouteRoute: AuthRouteRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
